import Refund from './index';

export default { path: '/home/refund', component: Refund };
